import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllLeasesByAdmin } from '../../redux/actions/LeaseActions';
import LeaseList from '../../components/leases/LeaseList';

const Leases = () => {
  const dispatch = useDispatch();

//   const { leases, pagination, loading } = useSelector(
//     (state) => state.adminLease
//   );

const {
    leases = [],
    pagination = null,
    loading = false
  } = useSelector((state) => state.lease || {});
  

  const [page, setPage] = useState(1);

  const handleFilter = (filter = {}) => {
    setPage(1);
    dispatch(
      fetchAllLeasesByAdmin({
        ...filter,
        page: 1,
        limit: 10
      })
    );
  };

  useEffect(() => {
    dispatch(fetchAllLeasesByAdmin({ page, limit: 10 }));
  }, [dispatch, page]);

  return (
    <div>
      <h2>All Leases</h2>

      <LeaseList
        leases={leases}
        pagination={pagination}
        page={page}
        setPage={setPage}
        onFilter={handleFilter}
        loading={loading}
      />
    </div>
  );
};

export default Leases;
